import React from "react";
import { useTranslation } from "react-i18next";

const StatusWidget = ({ status }) => {
  const { t } = useTranslation();

  const render = () => {
    switch (status) {
      case 1:
        return (
          <span className="bg-primarySM primary-color fw-5  pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
            {t("open")}
          </span>
        );
      case 2:
        return (
          <span className="bg-successXS success-color fw-5 pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
            {t("completed")}
          </span>
        );
      case 3:
        return (
          <span className="bg-graySM gray-color fw-5 pr-10 pl-10 pt-5 pb-5 br-25 fs-12 tx-upp">
            {t("voided")}
          </span>
        );
      default:
        break;
    }
  };

  return render();
};

export default StatusWidget;
